var _mask, _path, _path2, _mask2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLicencePlateSelectBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 24,
    viewBox: "0 0 112 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_3_7",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 6.175C0 2.76464 2.76464 0 6.175 0H15V23.5H6.175C2.76464 23.5 0 20.7354 0 17.325V6.175Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.175C0 2.76464 2.76464 0 6.175 0H15V23.5H6.175C2.76464 23.5 0 20.7354 0 17.325V6.175Z",
    fill: "#2B4C9C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-2 6.175C-2 1.66007 1.66007 -2 6.175 -2H15V2H6.175C3.86921 2 2 3.86921 2 6.175H-2ZM15 25.5H6.175C1.66007 25.5 -2 21.8399 -2 17.325H2C2 19.6308 3.86921 21.5 6.175 21.5H15V25.5ZM6.175 25.5C1.66007 25.5 -2 21.8399 -2 17.325V6.175C-2 1.66007 1.66007 -2 6.175 -2V2C3.86921 2 2 3.86921 2 6.175V17.325C2 19.6308 3.86921 21.5 6.175 21.5V25.5ZM15 0V23.5V0Z",
    fill: "black",
    mask: "url(#path-1-inside-1_3_7)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-2_3_7",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 0H105.825C109.235 0 112 2.76464 112 6.175V17.325C112 20.7354 109.235 23.5 105.825 23.5H15V0Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 0H105.825C109.235 0 112 2.76464 112 6.175V17.325C112 20.7354 109.235 23.5 105.825 23.5H15V0Z",
    fill: "#F0B504"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 -2H105.825C110.34 -2 114 1.66007 114 6.175H110C110 3.86921 108.131 2 105.825 2H15V-2ZM114 17.325C114 21.8399 110.34 25.5 105.825 25.5H15V21.5H105.825C108.131 21.5 110 19.6308 110 17.325H114ZM15 23.5V0V23.5ZM105.825 -2C110.34 -2 114 1.66007 114 6.175V17.325C114 21.8399 110.34 25.5 105.825 25.5V21.5C108.131 21.5 110 19.6308 110 17.325V6.175C110 3.86921 108.131 2 105.825 2V-2Z",
    fill: "black",
    mask: "url(#path-3-inside-2_3_7)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLicencePlateSelectBg);
export default __webpack_public_path__ + "static/media/licencePlateSelectBg.44310dad3d846c759d294a3ac03673da.svg";
export { ForwardRef as ReactComponent };